module.exports = __webpack_public_path__ + "img/21.db62d070.jpg";